<template>
  <v-row>
    <v-col>
      <SurgeryIndicationListItem
        v-for="surgeryIndication in surgeryIndications"
        :key="surgeryIndication.id"
        :attendance="attendance"
        :surgeryIndication="surgeryIndication"
        :refreshList="refreshList"
        :disabled="disabled"
      />
    </v-col>
  </v-row>
</template>

<script>
  import SurgeryIndicationListItem from "@/components/surgery_indication/list/item.vue";

  export default {
    name: "SurgeryIndicationList",
    props: {
      attendance: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      SurgeryIndicationListItem,
    },
    mounted() {
      this.refreshList();
    },
    apollo: {
      surgeryIndications: {
        query: require("@/graphql/surgery_indication/surgery_indications.gql"),
        variables() {
          return {
            attendanceId: this.attendance.id,
          };
        },
        update(data) {
          return this.lodash.orderBy(data.surgeryIndications, ["createdAt"], ["desc"]);
        },
        pollInterval: 20000,
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.surgeryIndications.refetch();
      },
    },
  };
</script>

<style lang="sass" scoped></style>
